export type DocumentRemovalNotice = {
  title: string;
  body: string;
};

export function documentRemovalSubmittedGuidance(): DocumentRemovalNotice {
  return {
    title: 'Document removed',
    body: 'Route42 stopped using this source as evidence immediately. Machine Memory is now being updated from the remaining active evidence; you can keep working while that finishes.',
  };
}

export function documentReconciliationCompletedGuidance(): DocumentRemovalNotice {
  return {
    title: 'Machine Memory updated',
    body: 'Reconciliation is complete. Route42 rebuilt this machine\'s current understanding without the removed source. Machine Memory now reflects only evidence that remains active.',
  };
}
